/** Dev-only timing helpers for the Orders page load waterfall. */

const enabled = import.meta.env.DEV;

let pageStartedAt = 0;

export function markOrdersShell() {
  if (!enabled) return;
  pageStartedAt = performance.now();
  console.info(`[orders:perf] shell +0ms`);
}

export function logOrdersNetwork(label: string, startedAt: number, extra?: Record<string, unknown>) {
  if (!enabled) return;
  const dur = Math.round(performance.now() - startedAt);
  const sinceShell = pageStartedAt ? Math.round(performance.now() - pageStartedAt) : undefined;
  console.info(`[orders:perf] ${label} dur=${dur}ms`, sinceShell != null ? `sinceShell=${sinceShell}ms` : "", extra ?? "");
}

export async function timedOrdersFetch<T>(label: string, fn: () => Promise<T>, extra?: Record<string, unknown>): Promise<T> {
  if (!enabled) return fn();
  const startedAt = performance.now();
  try {
    const result = await fn();
    logOrdersNetwork(label, startedAt, extra);
    return result;
  } catch (error) {
    logOrdersNetwork(`${label}:error`, startedAt, extra);
    throw error;
  }
}
